import { render, staticRenderFns } from "./QLZoneCompetenza.vue?vue&type=template&id=0f9e4c7a&"
import script from "./QLZoneCompetenza.vue?vue&type=script&lang=js&"
export * from "./QLZoneCompetenza.vue?vue&type=script&lang=js&"
import style0 from "./QLZoneCompetenza.vue?vue&type=style&index=0&id=0f9e4c7a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports